import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fal, far, fas, fab } from '@awesome.me/kit-e466b8b74d/icons/modules';

// Add icons
library.add(fal, far, fas, fab);

// Register component globally
Vue.component('fa-icon', {
  functional: true,
  render(h, ctx) {
    const data = {
      ...ctx.data,
      class: ['fa-icon', ctx.data.class],
    };

    return h('i', data, [h(FontAwesomeIcon, ctx.data, ctx.children)]);
  },
});
